export const PNP_GUEST_UNIT_COVERAGE_ID = '114932';
export const PNP_GUEST_UNIT_NAME_MATCH = 'guest unit';
